import React from "react";
import FilterBar from "../../components/FilterBar/FilterBar";
import { InstanceTable } from "../../components/table/InstanceTable";
import Logo from "../../assets/union.svg";

export const PriceComparison: React.FC = () => {
  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="flex gap-4 text-2xl font-semibold text-gray-800">
          <img src={Logo} alt="Logo" className="w-8 h-8" />
          Cloud Instance Price Comparison
        </h1>
        <p className="text-sm text-gray-500 mt-1">
          Compare VM instance pricing across AWS, GCP, and Azure with flexible
          time units and export options.
        </p>
      </div>

      <FilterBar />
      <InstanceTable />
    </div>
  );
};
